import { AxiosResponse } from 'axios';
import { IChannel } from '.';

export type FlowItemType = 'action' | 'condition' | 'delay' | null;

export enum ActionType {
  SEND_MESSAGE = 'SEND_MESSAGE',
}

export enum DelayUnit {
  seconds = 'seconds',
  minutes = 'minutes',
  hours = 'hours',
  days = 'days',
}

export type InstagramButton = {
  title: string;
  url: string;
};

export type InstagramQuickReply = {
  title: string;
  payload: string;
};

export interface FlowItem {
  type: FlowItemType;
  id: string;
  data: {
    action?: ActionType;
    templateId?: string | null;
    templateName: string | null;
    templateContent?: string | null;
    delay: number | null;
    delayUnit: DelayUnit | null;
    followupDelays?: {
      value: number | null;
      unit: DelayUnit;
      content?: string | null;
    }[];
    buttons?: InstagramButton[] | null;
    quickReplies?: InstagramQuickReply[] | null;
    audioUrl?: string | null;
    videoUrl?: string | null;
  };
}

export type WorkingHoursConfig = {
  enabled: boolean;
  from: string | null;
  to: string | null;
  timezone: string | null;
};

export type SequenceEditorValues = {
  name: string | null;
  trigger: string | null;
  agent: string | null;
  profileId: string | null;
  isSwitchOn: boolean;
  shouldContinueExistingConversations: boolean;
  disableAiOnManualConversations: boolean;
  inboundResponseDelay: number | null;
  inboundResponseDelayUnit: DelayUnit | null;
  flowItems: FlowItem[];
  source: string | null;
  workingHours?: WorkingHoursConfig;
  keywords?: string[] | null;
  targetMediaIds?: string[] | null;
  enableAgentOnConversation: boolean;
  requireManualApproval: boolean;
};

export type Step = {
  TemplateID: string;
  Name: string;
  Content: string;
  Delay: number;
  DelayUnit: DelayUnit;
};

// Type for fetching sequences
export interface SequencePreview {
  Active: boolean;
  ID: string;
  Name: string;
  Trigger: string;
  Channel: IChannel;
  ProfileID?: string | null;
  DisabledReason?: string | null;
}

// Type for creating a sequence
export interface CreateSequence {
  Name: string;
  Trigger: string;
  InboundResponseDelay: number | null;
  InboundResponseDelayUnit: DelayUnit | null;
  Flow:
    | {
        Delay: number;
        DelayUnit: DelayUnit;
        TemplateID: string;
      }[]
    | null;
  AgentID?: string | null;
}

// Type for fetching a sequence by ID
export interface Sequence {
  Active: boolean;
  ID: string;
  Name: string;
  Trigger: string;
  Flow: {
    Steps: Step[];
  };
  InboundResponseDelay: number;
  InboundResponseDelayUnit: DelayUnit;
  Agent: {
    ID: string;
    Name: string;
  };
}

// Type for updating sequence status
export interface UpdateSequenceStatus {
  Active: boolean;
}

export type GetSequencesResponse = AxiosResponse<SequencePreview[]>;

export type GetSequenceByTriggerResponse = AxiosResponse<SequencePreview[]>;

export type GetSequenceByIDResponse = AxiosResponse<Sequence>;

export type UpdateSequenceStatusResponse = AxiosResponse<UpdateSequenceStatus>;

export type CreateSequenceResponse = AxiosResponse<string>;

export type UpdateSequenceResponse = AxiosResponse<string>;
